module.exports = __webpack_public_path__ + "assets/img/bank.640632f8.png";